import React from "react";
import { useAuth } from "../contexts/AuthContext";
import LoginPage from "./LoginPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthorized, signOut } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  if (!isAuthorized) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="w-full max-w-md rounded-2xl bg-white shadow-lg border border-gray-100 p-8 text-center">
          <h1 className="text-xl font-semibold text-gray-900">Approval required</h1>
          <p className="mt-2 text-sm text-gray-600">
            You signed in as <span className="font-medium">{user.email}</span>, but
            this account has not been approved yet.
          </p>
          <p className="mt-3 text-sm text-gray-500">
            Ask the dashboard owner to approve your access. Once approved, refresh
            this page to continue.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 mr-3 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Refresh
          </button>
          <button
            type="button"
            onClick={signOut}
            className="mt-4 rounded-lg bg-purple-600 px-4 py-2 text-sm font-medium text-white hover:bg-purple-700"
          >
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
